<template>
  <div
    class="banner"
    ref="banner_parent"
    :class="[
      {
        small:
          _.includes(_.get(contentData, 'conf.conf'), 'layout-1') ||
          _.includes(_.get(contentData, 'conf.conf'), 'offer_list_layout')
      },
      { 'layout-2': _.includes(_.get(contentData, 'conf.conf'), 'layout-2') }
    ]"
  >
    <picture>
      <source
        media="(max-width: 767px)"
        :srcset="_.get(contentData, 'data.list[0].image[0].devices.mobile')"
      />
      <source
        media="(max-width: 1023px)"
        :srcset="_.get(contentData, 'data.list[0].image[0].devices.tablet')"
      />
      <img
        :src="_.get(contentData, 'data.list[0].image[0].devices.desktop')"
        ref="prlx"
        :prlx-val="
          _.includes(_.get(contentData, 'conf.conf'), 'layout-1') ||
          _.includes(_.get(contentData, 'conf.conf'), 'offer_list_layout')
            ? 30
            : 10
        "
        alt
      />
    </picture>
    <div class="container">
      <div class="row flex column al-center">
        <div class="title bold uppercase" v-html="coloredTeaser"></div>
        <div
          class="teaser bold uppercase"
          v-if="
            (_.get(contentData, 'data.list[0].teaser') &&
              !_.includes(
                _.get(contentData, 'conf.conf'),
                'offer_list_layout'
              )) ||
              !_.includes(_.get(contentData, 'conf.conf'), 'layout-1')
          "
        >
          {{ _.get(contentData, "data.list[0].teaser") }}
        </div>
      </div>

      <a
        v-if="!_.includes(_.get(contentData, 'conf.conf'), 'offer_list_layout')"
        :href="dynamicUrl"
        :target="
          _.get(contentData, 'data.list[0].url.url_target') == '_blank'
            ? '_blank'
            : '_self'
        "
        class="learn-more pointer uppercase flex al-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27.279"
          height="27.279"
          viewBox="0 0 27.279 27.279"
        >
          <path
            id="Path_1609"
            data-name="Path 1609"
            d="M593.22,257a13.64,13.64,0,1,0,13.64,13.64A13.64,13.64,0,0,0,593.22,257m0,24.1a10.46,10.46,0,0,1-8.435-16.658l8.414,8.414h-6.368v3.171h11.793V264.217h-3.158v6.368l-8.414-8.414a10.464,10.464,0,1,1,6.189,18.9"
            transform="translate(-579.58 -257)"
            fill="#f7f7f7"
          />
        </svg>

        {{
          _.get(contentData, "data.list[0].url.title") || $fn.tr("გაიგე მეტი")
        }}
      </a>
    </div>
  </div>
</template>

<script>
import set_prlx from "@/mixins/prlx";
export default {
  props: ["contentData"],
  mixins: [set_prlx],
  computed: {
    coloredTeaser() {
      const title = _.get(this.contentData, "data.list[0].title");
      const splitText = title ? title.split(" ") : "";

      if (
        (!_.includes(_.get(this.contentData, "conf.conf"), "layout-1") &&
          !_.includes(
            _.get(this.contentData, "conf.conf"),
            "offer_list_layout"
          )) ||
        !splitText
      ) {
        return title;
      }
      return `<span>${splitText[0]}</span> ${splitText
        .splice(1, splitText.length)
        .join(" ")}`;
    },
    dynamicUrl() {
      const link = _.get(this.contentData, "data.list[0].url.url");
      if (!link?.includes("http")) {
        return `/${this.$store.state.main.locale}${link}`;
      } else {
        return link;
      }
    }
  }
};
</script>

<style lang="scss">
.banner {
  position: relative;
  width: 100%;
  height: 610px;
  background: $black;
  overflow: hidden;
  &.layout-2 {
    height: 233px;
    .container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      @media (max-width: 1023px) {
        flex-direction: column;
        justify-content: center;
      }
      .row {
        align-items: flex-start;
        @media (max-width: 1023px) {
          align-items: center;
        }
      }
      .title {
        color: $white;
        margin-bottom: 6px;
      }
      .teaser {
        margin-top: 0px;
      }
    }
  }
  &.small {
    height: 233px;
    .title {
      span {
        color: $white;
        font-size: 55px;
        // font-family: "Hm-Pangram-bold";
        font-family: "Firago-Book";
        @media (max-width: 767px) {
          font-size: 34px;
        }
      }
    }
  }
  img {
    position: absolute;
    // width: 100%;
    // height: 100%;
    // top: -40%;
    // left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.5;
    @media (min-width: 768px) {
      width: 140%;
      height: 140%;
    }
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .learn-more {
      margin-top: 38px;
      width: fit-content;
      height: 50px;
      border: 2px solid #ffffff;
      background: $black;
      padding: 0 10px;
      color: $white;

      @media (max-width: 767px) {
        margin-top: 34px;
        height: 40px;
        font-size: 16px;
        svg {
          width: 20px;
        }
      }
      svg {
        transition: 0.2s ease;
        transform: rotate(0deg);
        margin-right: 10px;
        will-change: transform;
      }
      &:hover {
        svg {
          transform: rotate(-45deg);
        }
      }
    }
    .title {
      color: $yellow;
      font-size: 55px;
      @media (max-width: 767px) {
        font-size: 34px;
        text-align: center;
      }
    }
    .teaser {
      margin-top: 38px;
      color: $white;
      @media (max-width: 1359px) {
        margin-top: 21px;
      }
    }
  }
  @media (max-width: 1599px) {
    height: 455px;
  }
  @media (max-width: 1023px) {
    height: 345px;
  }
}
</style>
